import { useEffect } from "react";
import { I18nProvider } from "@lingui/react";
import { i18n } from "@lingui/core";

import { activateLocale } from "../i18n";
import { useConsentStore } from "../state/consentStore";
import { useGameStore } from "../state/store";
import { AppShell } from "../components/layout/AppShell";
import { ConsentBanner } from "../components/consent/ConsentBanner";
import { HintOverlay } from "../components/tutorial/HintOverlay";
import { TutorialOverlay } from "../components/tutorial/TutorialOverlay";
import { ErrorBoundary } from "./ErrorBoundary";
import { Router } from "./Router";

export function App(): JSX.Element {
  const language = useGameStore((state) => state.settings.language);
  const screen = useGameStore((state) => state.currentScreen);
  const inGame = useGameStore((state) => state.inGame);
  const consent = useConsentStore((state) => state.consent);
  const focal = screen === "main_menu" || screen === "results";
  const chrome = inGame;

  useEffect(() => {
    void activateLocale(language);
  }, [language]);

  return (
    <I18nProvider i18n={i18n}>
      <ErrorBoundary>
        {focal ? (
          <Router />
        ) : (
          <AppShell chrome={chrome}>
            <Router />
          </AppShell>
        )}
        <TutorialOverlay />
        <HintOverlay />
        {consent === null && <ConsentBanner />}
      </ErrorBoundary>
    </I18nProvider>
  );
}
